module.exports = __webpack_public_path__ + "img/previous.8c436dfe.svg";